import React, { Component } from "react"
import { connect } from "react-redux"
import styled, { injectGlobal, css } from 'styled-components'
import Link, { navigateTo, push } from "gatsby-link"
import { find } from 'lodash'
import { rgba } from 'polished'

import { MetaTags } from '../components'

import { fetchSettings, getSettings } from '../store/settings'

import { warmBrown } from '../styles/themes'
import { container, bgImage, button, bgIcon, innerContainer, hoverState } from '../styles/global'
import { heading2, paragraph, caption } from '../styles/type'
import { media } from '../styles/utils'
import { grey } from '../styles/colors'

const PROJECTS_PAGE_SIZE = 10;

class Projects extends Component {

	state = {
        data: [],
        visibleCount: PROJECTS_PAGE_SIZE,
	}

    componentWillMount = () => {
        this.props.fetchSettings()
        this.setState({
			data: this.props.data.allWordpressProjects.edges
		})
    }

    loadMore = () => {
        this.setState({
            visibleCount: this.state.visibleCount + PROJECTS_PAGE_SIZE,
        })
    }

    renderProjects = () => {
        const { data, visibleCount } = this.state;

        if (!data || data.length === 0) return null;

        const visible = data.slice(0, visibleCount);
        const hasMore = data.length > visibleCount;

        const projects = visible.map((project, i) => {
            const acf = JSON.parse(project.node.acf_json);

            return (
                <Item key={i}>
                    <ListImageLink
                        image={acf.hero_image.sizes.large}
                        to={`/project/${project.node.slug}`}
                    />

                    <TitleLink to={`/project/${project.node.slug}`}>
                        {project.node.title}
                    </TitleLink>
                </Item>
            )
        })

        return (
            <React.Fragment>
                <Listing>{projects}</Listing>

                {hasMore && (
                    <LoadMoreWrapper>
                        <LoadMoreButton onClick={this.loadMore}>
                            View More
                        </LoadMoreButton>
                    </LoadMoreWrapper>
                )}
            </React.Fragment>
        )
    }

  	render() {
        const splashActive = this.props.settings.splashActive;
        const { data } = this.state;

        let firstPostACF;
        if (data) {
            firstPostACF = JSON.parse(data[0].node.acf_json);           
        }
       
		return (
			<Wrapper
                active={splashActive == false}
            >
                {data && firstPostACF && (
                    <MetaTags 
                        title={`Paul Conrad Architects — Projects`}
                        description={``}
                        url={`https://www.conradarchitects.com/projects`}
                        image={firstPostACF.hero_image.sizes.medium2}
                    />
                )}              
                
                {this.renderProjects()}

			</Wrapper>
		)	
  	}
}



const Wrapper = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;	
	width: 100%;
	z-index: 2;
    padding-top: 10rem;
    transition: all 0.75s ease;
	transition-delay: 0.4s;
	will-change: transform;
    transform: translateY(100px);
	opacity: 0;

	${media.phone`
        padding-top: 0;
	`}

	${props => {
		if (props.active) return css`
			transform: translateY(0);
			opacity: 1;
		`
	}}
`


const Listing = styled.div`
    ${innerContainer};
    display: flex;
    flex-flow: row wrap;
    margin-bottom: 10rem;

	${media.phone`
        flex-direction: column;
	`}
`

const Item = styled.div`
    flex: 0 1 50%;
    margin-bottom: 5rem;
    box-sizing: border-box;

	${media.phone`
        flex: none;
	`}

    &:nth-child(odd) {
        padding-right: 2.5rem;

        ${media.phone`
            padding-right: 0;
        `}
    }

    &:nth-child(even) {
        padding-left: 2.5rem;

        ${media.phone`
            padding-left: 0;
        `}
    }
`

const ListImageLink = styled(Link)`
    display:flex;
    position: relative;
	background-image: url(${props => props.image});
	${bgImage}
	height: 294px;
	width: 100%;

	${media.laptop`
		height: 228px;
	`}

	${media.tablet`
		height: 196px;
	`}

	${media.phone`
		height: 198px;
	`}
`

const TitleLink = styled(Link)`
    display: flex;
    margin-top: 10px;
	font-family: 'Scto';
    font-weight: 300;
    font-size: 16px;
    line-height: 1;
    color: ${grey};
    ${hoverState};

	${media.tablet`
        font-size: 12px;
	`}
`

const LoadMoreWrapper = styled.div`
    ${innerContainer};
    display: flex;
    justify-content: center;
    margin-top: 2rem;
    margin-bottom: 10rem;
`

const LoadMoreButton = styled.div`
    background: #F5F4F2;
    color: ${grey};
    font-size: 16px;
    line-height: 1;
    padding: 14px 32px;
    cursor: pointer;
    ${hoverState};

    ${media.phone`
        font-size: 14px;
    `}
`



const mapDispatchToProps = dispatch => ({
    fetchSettings() {
        dispatch(fetchSettings())
    },
    updateSettings(setting) {
        dispatch(updateSettings(setting))
    },
})

const mapStateToProps = (state, props) => ({
    settings: state.settings.settings
})

export default connect(mapStateToProps, mapDispatchToProps)(Projects);


export const pageQuery = graphql `
	query Projects {
		allWordpressProjects {
            edges {
                node {
                    title
                    slug
                    acf_json
                }
            }
        }
	}
`


// WEBPACK FOOTER //
// ./src/pages/Projects.js